"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
class SupplementalCoverages {
    constructor(data) {
        this.coverageExtensions = data.coverageExtensions;
        this.supplementalCoveragesDetails = data.supplementalCoveragesDetails;
    }
    static empty() {
        const data = {
            coverageExtensions: {
                rewardExpense: null
            },
            supplementalCoveragesDetails: _1.SupplementalCoveragesDetails.empty()
        };
        return new SupplementalCoverages(data);
    }
    static fromObj(data) {
        if (!data)
            return SupplementalCoverages.empty();
        return new SupplementalCoverages({
            coverageExtensions: data.coverageExtensions,
            supplementalCoveragesDetails: _1.SupplementalCoveragesDetails.fromObj(data.supplementalCoveragesDetails)
        });
    }
}
exports.default = SupplementalCoverages;
//# sourceMappingURL=supplementalCoverages.class.js.map